import { render, staticRenderFns } from "./SpecRow.vue?vue&type=template&id=0a4b5820&scoped=true&lang=pug&"
import script from "./SpecRow.vue?vue&type=script&lang=js&"
export * from "./SpecRow.vue?vue&type=script&lang=js&"
import style0 from "./SpecRow.vue?vue&type=style&index=0&id=0a4b5820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b5820",
  null
  
)

export default component.exports